// flow weak

/* eslint no-console:0 */
/* eslint consistent-return:0 */

/*
  imports
 */
import moment               from 'moment';
import { appConfig }        from '../../config';
import {
  getGameInfoData
}                           from '../../services/API';
import {
  fetchMockstatsTableData
}                           from '../../services/fetchMocks';
import * as ReduxTypes      from '../types';

/*
  constants
 */
const REQUEST_GAMEINFO_DATA   = 'REQUEST_GAMEINFO_DATA';
const RECEIVED_GAMEINFO_DATA  = 'RECEIVED_GAMEINFO_DATA';
const ERROR_GAMEINFO_DATA     = 'ERROR_GAMEINFO_DATA';


let gameinfo = {
  isFetching: false,
  // headers:     [],
  data:   null,
  // requested_venue_id: 0,
  // venue_id: -1,
  time:       null
};

/*
  reducer
 */
  let initialStateCopy = {};
  for (var property in appConfig.gameinfo.data) {
      // console.log(property);
      // console.log(appConfig.gameinfo.data.hasOwnProperty(property));
      // console.log(Object.getOwnPropertyNames(appConfig.gameinfo.data));
    if (appConfig.gameinfo.data.hasOwnProperty(property) && property != "API") {
        initialStateCopy[property] = Object.assign({}, gameinfo);
        initialStateCopy[`reset::${property}`] = Object.assign({}, gameinfo);
    }
  } 
  const initialState = initialStateCopy;
  // const initialState = gameinfo;

export default function gameinfo(state = initialState, action) {
  console.log(initialState);
  console.log("GameInfo plan call - API");
  console.log(appConfig.gameinfo.data);
  console.log(action);
  let data = initialState;
  // return state
  switch (action.type) {
  case 'CHANGE_LOCATION_FOR_GAMEINFO_PLAN':
    console.log("SH - REQUEST_LOCATION_CHANGE");
    console.log(state);
    data[action.name].requested_venue_id = action.selectedLocation;
    return Object.assign({}, state, data);
  case 'REFRESH_GAMEINFO_DATA':
    console.log("SH- REFRESH_GAMEINFO_DATA");
    fetchGameInfoDataIfNeeded(action.venue_id,action.name);
    return state;        
  case 'REQUEST_GAMEINFO_DATA':
    console.log("SH - REQUEST_GAMEINFO_DATA data");
    console.log(state);
    console.log(action);
    console.log(data);
    data[action.name].isFetching = action.isFetching;
    data[action.name].time = action.time;
    return Object.assign({}, state, data);
  case 'RECEIVED_GAMEINFO_DATA':
    console.log("SH - RECEIVED_GAMEINFO_DATA data");
    console.log(action);
    console.log(state);
    data[action.name].isFetching = action.isFetching;
    data[action.name].time = action.time;
    // data[action.name].headers = action.headers;
    data[action.name].data = action.data;
    // data[action.name].venue_id = action.venue_id;
    let newstate = Object.assign({}, state, data);
    console.log(newstate);
    return newstate;
  case 'ERROR_GAMEINFO_DATA':
    data[action.name].isFetching = action.isFetching;
    data[action.name].time = action.time;
    data[action.name].headers = [];
    data[action.name].data = [[]];
    //To avoid api loop
    //Stop at first api error.
    data[action.name].venue_id = state[action.name].requested_venue_id;    
    return Object.assign({}, state, data);
  default:
    return state;
  }
}


/*
  action creators
 */
// export function fetchGameInfoDataIfNeeded(id=0,name) {
export function fetchGameInfoDataIfNeeded(name) {
    console.log("SP ifNeeded");
    console.log(name);
  return (
    dispatch, 
    getState
  ) => {
    // if (shouldFetchGameInfoData(getState(),name)) {
    if (shouldFetchGameInfoData(getState(), name) || name.split("::")[0] == "reset") {
      // return dispatch(fetchGameInfoData(id,name));
      return dispatch(fetchGameInfoData(name));
    }
  };
}
export function throwGameInfoDataHandler(name, payload) {
    console.log("SP if throw handler");
  return (
    dispatch, 
    getState
) => dispatch(throwGameInfoData(name, payload));
}

function requestGameInfoData(name,time = moment().format()) {
  return {
    type:       REQUEST_GAMEINFO_DATA,
    isFetching: true,
    time,name
  };
}
function receivedGameInfoData(data,name, time = moment().format()) {
    console.log("receivedGameInfoData");
    console.log(data);
  return {
    type:       RECEIVED_GAMEINFO_DATA,
    isFetching: false,
    // headers:     [...data.headers],
    data:   data,
    // venue_id:   data.venue_id,
    time,name
  };
}
function errorGameInfoData(error,name, time = moment().format()) {
  return {
    type:       ERROR_GAMEINFO_DATA,
    isFetching: false,
    error,
    time,name
  };
}
function fetchGameInfoData(name) {
    // console.log(id);
    console.log(name);
    console.log("SH fetchGameInfoData");
  return dispatch => {
    dispatch(requestGameInfoData(name));
    if(name.split("::")[0] == "reset"){
        dispatch(receivedGameInfoData({"data":null,"headers":[]},name.split("::")[1] ));
    } else if (name == "gametypes"){
      getGameInfoData(name)
        .then(
          data => dispatch(receivedGameInfoData(data,name))
        )
        .catch(
          error => dispatch(errorGameInfoData(error,name))
        );      
    }
    else{
        //Redux data clearing request.
        dispatch(receivedGameInfoData({"venue_id":-1,"data":[[]],"headers":[],"title":"Empty"},name))
      }

  };
}
function throwGameInfoData(name, payload) {
    // console.log(id);
    console.log(name);
    console.log("SH throwGameInfoData");
  return dispatch => {
    dispatch(requestGameInfoData(name));
    if(name.split("::")[0] == "reset"){
        dispatch(receivedGameInfoData({"data":null,"headers":[]},name.split("::")[1] ));
    } else if (name != ""){
        postGameInfoData(name, payload)
          .then(
            data => dispatch(receivedGameInfoData(data,name))
          )
          .catch(
            error => dispatch(errorGameInfoData(error,name))
          );
    } else{
        //Redux data clearing request.
        dispatch(receivedGameInfoData({"venue_id":-1,"data":[[]],"headers":[],"title":"Empty"},name))
      }

  };
}

function shouldFetchGameInfoData(state,name) {
    console.log(state);
  const spStore = state.gameinfo[name];
  if (spStore.isFetching) {
    return false;
  } else {
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/modules/gameinfo.js